// Wesleyan University's undergraduate majors (#2743). Read on 2026-10-01
// (in a browser; wesleyan.edu refuses plain downloads) from the Areas of
// Study list on wesleyan.edu, which gives each program its degree types and
// its division and names each major it offers ("Biology Major", "French
// Studies Major"): every major kept, the word "Major" dropped from the name.
// Programs listed only as a minor, certificate or graduate degree are left
// out. The list names no degree for its majors, so the degree is null. The
// University Major (self-designed, planned in the sophomore year) carries no
// division and sits in its own group; Integrative Sciences is noted as the
// linked major the list calls it. The KB's majors list was the starting
// point; the official list wins.
const majors = {
    "slug": "wesleyan-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major on Wesleyan's Areas of Study list, grouped by the academic division the list names for it. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Arts and Humanities Division",
            "source": {
                "label": "Wesleyan, Areas of Study (filter: Major)",
                "url": "https://www.wesleyan.edu/academics/areas-of-study/index.html"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Art Studio",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "College of Letters",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "East Asian Studies",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null
                },
                {
                    "name": "French Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Hispanic Literatures and Cultures",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Romance Studies",
                    "degree": null
                },
                {
                    "name": "Theater",
                    "degree": null
                }
            ]
        },
        {
            "name": "Natural Sciences and Mathematics Division",
            "source": {
                "label": "Wesleyan, Areas of Study (filter: Major)",
                "url": "https://www.wesleyan.edu/academics/areas-of-study/index.html"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "College of Science and Technology Studies",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Integrated Design, Engineering, Art, and Society",
                    "degree": null
                },
                {
                    "name": "Integrative Sciences",
                    "degree": null,
                    "note": "A linked major, taken together with another major."
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Molecular Biology and Biochemistry",
                    "degree": null
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Social Sciences Division",
            "source": {
                "label": "Wesleyan, Areas of Study (filter: Major)",
                "url": "https://www.wesleyan.edu/academics/areas-of-study/index.html"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Archaeology",
                    "degree": null
                },
                {
                    "name": "College of Social Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education Studies",
                    "degree": null
                },
                {
                    "name": "Feminist, Gender, and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "Global South Asian Studies",
                    "degree": null
                },
                {
                    "name": "Government",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Self-designed",
            "source": {
                "label": "Wesleyan, Areas of Study (filter: Major)",
                "url": "https://www.wesleyan.edu/academics/areas-of-study/index.html"
            },
            "majors": [
                {
                    "name": "University Major",
                    "degree": null,
                    "note": "A program you design yourself, proposed in your sophomore year."
                }
            ]
        }
    ]
};

export default majors;
